import Vue from "vue";
import Router from "vue-router";
import index from './router/index';
import { resolve } from "path";

Vue.use(Router);
const scrollBehavior = (to, from, savedPosition) => {
  if (savedPosition) {
    return savedPosition;
  } else {
    document.getElementById("app").scrollTop = 0;
  }
};
export default new Router({
  // mode: "history",
  base: process.env.BASE_URL,
  scrollBehavior,
  routes: [].concat(index)
});
